import { Component } from '@angular/core';
// Ancien import du tuto qui ne marche plus
// import * as firebase from 'firebase';
// !! Du coup ne pas oublier d'impoter les autres modules comme auth et firestore!!
import firebase from 'firebase/app';
import 'firebase/auth';
import "firebase/firestore";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {
    // Lui met ce code dans le constructeur de l'app générale, mais dans la documentation, ils le mettent juste en script dans le body et utilisent un CDN pour récupérer firebase.
    // J'ai testé, on peut aussi le mettre dans un ngOnInit

    // Your web app's Firebase configuration
    var firebaseConfig = {
      apiKey: "AIzaSyCkkOVS11FkDEddtnhfGhT7VaRTQSujnIM",
      authDomain: "angular-bibliotheque-9691c.firebaseapp.com",
      projectId: "angular-bibliotheque-9691c",
      storageBucket: "angular-bibliotheque-9691c.appspot.com",
      messagingSenderId: "241290291071",
      appId: "1:241290291071:web:b0377e7cfbb8865a23dc4a"
    };
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    // console.log('Firebase marche');
  }
}
